import { } from '../../../assets';

export const team = [
  // {
  //   name: "",
  //   pronouns: "",
  //   discipline: "",
  //   role: "",
  //   image: ,
  //   funfact: "",
  //   instagram: "",
  //   linkedin: "",
  //   github: "",
  //   youtube: ""
  // },
]